module.exports = __webpack_public_path__ + "bc4ddef799cd004fe4344470f3af7cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/familyActivities/Assets/Fridge_game.png
// module id = 1360
// module chunks = 0